export default "__VITE_ASSET__QRvoJrsX__"